import { createUseStyles } from 'react-jss';

const styles = {
  content: { paddingBottom: '5rem', position: 'relative', minHeight: '10rem' },
  tableContent: { maxWidth: '80vw' },
  bcForm: { paddingLeft: '2rem' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
